/**
 * Somebody to find.
 *
 * An errand that is a person rather than a thing: a beat `posts` one, and it
 * is over when you find them or when the day they could be found is. Who is
 * being looked for is on their own row in `staff.js` (`sought`), because no
 * row anywhere else names a member of staff, and so is what they say when you
 * find them (`says.phone`, `says.found`).
 *
 *   until    the time it lapses, which is when they go home
 *   recent   game minutes a sighting is still worth mentioning when asked
 *   then     where they go once found, in feet, a path: what they were
 *            needed for. They stay at the last point until they go home
 *   award    what finding them is worth, through standing like any award
 *   asked    what somebody says when you ask, with {name}, {where}, {ago}
 *            and {going} filled in from what they saw; `unseen` when they
 *            have not seen them lately
 *   found    the line on the screen once they are on their way
 */
export const SEARCHES = [
  {
    id: 'find-juanito',
    title: 'Find Juanito',
    until: '16:00',
    recent: 120,
    // Out round the pocket door and onto the floor, to run the walls out.
    then: [[103, 58], [97, 58], [90, 52]],
    award: { banquets: 6 },
    asked: {
      seen: '{name}? I saw him {where} {ago}{going}.',
      unseen: '{name}? Not since this morning.',
    },
    found: '{name} is on his way.',
  },
];

export const SEARCHES_BY_ID = Object.freeze(Object.fromEntries(SEARCHES.map((row) => [row.id, row])));

export default SEARCHES;
